//  Modern Header Komponenti
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bell, Search, Settings, LogOut, User, Menu } from 'lucide-react';
import ThemeToggle from '../../common/ThemeToggle/ThemeToggle';

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();

  const getUserData = () => {
    try {
      const userData = localStorage.getItem('tegim-user');
      if (userData && userData !== 'null') {
        return JSON.parse(userData);
      }
      return null;
    } catch {
      return null;
    }
  };

  const user = getUserData();

  const logout = () => {
    localStorage.removeItem('tegim-token');
    localStorage.removeItem('tegim-refresh-token');
    localStorage.removeItem('tegim-user');
    localStorage.removeItem('tegim-expires-at');
    navigate('/login', { replace: true });
  };

  const getUserInitials = () => {
    if (user?.name) return user.name.split(' ').map(n => n[0]).join('').toUpperCase();
    if (user?.username) return user.username.substring(0, 2).toUpperCase();
    return 'U';
  };

  const getDisplayName = () => {
    return user?.name || user?.username || 'Kullanıcı';
  };

  return (
    <header className="sticky top-0 z-40 bg-primary border-b border-primary">
      <div className="flex items-center justify-between h-16 px-5">
        {/*  Sol Bölüm - Mobile Menu ve Search */}
        <div className="flex items-center gap-3 flex-1">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 hover:bg-hover rounded transition-all"
          >
            <Menu className="w-5 h-5" style={{ color: 'var(--text-secondary)' }} />
          </button>

          {/*  Search Bar - Minimal */}
          <div className="hidden md:flex items-center gap-2 flex-1 max-w-md">
            <div className="relative w-full">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4" style={{ color: 'var(--text-tertiary)' }} />
              <input
                type="text"
                placeholder="Ara... (Ctrl+K)"
                className="input pl-9 pr-3 py-2 text-sm"
                style={{ backgroundColor: 'var(--bg-secondary)' }}
              />
            </div>
          </div>
        </div>

        {/*  Sağ Bölüm - Actions */}
        <div className="flex items-center gap-2">
          {/*  Notifications */}
          <button className="relative p-2 hover:bg-hover rounded transition-all">
            <Bell className="w-5 h-5" style={{ color: 'var(--text-secondary)' }} />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-error rounded-full"></span>
          </button>

          {/*  Theme Toggle */}
          <ThemeToggle />

          {/*  Settings */}
          <button className="p-2 hover:bg-hover rounded transition-all">
            <Settings className="w-5 h-5" style={{ color: 'var(--text-secondary)' }} />
          </button>

          {/*  User Menu - Minimal, sade */}
          <div className="relative group">
            <button className="flex items-center gap-2 px-3 py-1.5 hover:bg-hover rounded transition-all">
              <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-medium">
                  {getUserInitials()}
                </span>
              </div>
              <div className="hidden lg:block text-left">
                <p className="text-sm font-medium leading-none" style={{ color: 'var(--text-primary)' }}>
                  {getDisplayName()}
                </p>
              </div>
            </button>

            {/*  Dropdown - Minimal */}
            <div className="dropdown absolute right-0 top-full mt-2 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div className="p-3 border-b border-primary">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-sm font-medium">
                      {getUserInitials()}
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-sm truncate" style={{ color: 'var(--text-primary)' }}>
                      {getDisplayName()}
                    </p>
                    <p className="text-xs truncate" style={{ color: 'var(--text-tertiary)' }}>
                      {user?.email || `${user?.username}@tegim.app`}
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-1">
                <Link to="/settings" className="dropdown-item">
                  <User className="w-4 h-4" />
                  <span>Profil</span>
                </Link>
                <Link to="/settings" className="dropdown-item">
                  <Settings className="w-4 h-4" />
                  <span>Ayarlar</span>
                </Link>
              </div>

              <div className="p-1 border-t border-primary">
                <button
                  onClick={logout}
                  className="dropdown-item w-full text-error"
                >
                  <LogOut className="w-4 h-4" />
                  <span>Çıkış Yap</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
